import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import { AgreeingToTerms, RegisterAccount } from '@flix/common/domain/membership'
import messages from '@flix/common/domain/membership/messages'
import { B, H1, Paragraph } from '@flix/common/elements/typography'
import { PayPalSubscriptionButton } from '../../../../containers/paypal/PayPalSubscriptionButton'

const Container = styled(View)`
  margin: ${(props) => props.theme.spacing.xlarge}px auto;
  padding: 0 ${(props) => props.theme.spacing.medium}px;
  max-width: 380px;
`

const Instructions = styled(Paragraph)`
  align-content: center;
  text-align: center;
  margin: ${(props) => props.theme.spacing.medium}px 0;
`

const ButtonContainer = styled(View)`
  margin: ${(props) => props.theme.spacing.medium}px 0 ${(props) => props.theme.spacing.larger}px;
`

const LastWords = styled(Paragraph)`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  text-align: center;
`

export const PayPalCheckoutContent = ({
  chosenPlan = {},
  onRequestChange,
  onPressPolicy,
  onPressTerms,
}) => {
  return (
    <Container>
      <H1 center>
        <FormattedMessage {...messages.payPalTitle} />
      </H1>

      <Instructions>
        <FormattedMessage
          {...messages.payPalInstructions}
          values={{ plan: <B>{chosenPlan.title}</B> }}
        />
      </Instructions>

      <RegisterAccount.ChangePlanLink onRequestChange={onRequestChange} />

      <ButtonContainer>
        <PayPalSubscriptionButton chosenPlan={chosenPlan} />
      </ButtonContainer>

      {chosenPlan?.hasFreeTrial && (
        <LastWords>
          <FormattedMessage {...messages.noCommitCancel} />
        </LastWords>
      )}

      <AgreeingToTerms onPressPolicy={onPressPolicy} onPressTerms={onPressTerms} />
    </Container>
  )
}
